const GTM_DEBUG = process.env.REACT_APP_GTM_DEBUG === 'true';

export function trackEvent(eventName, payload = {}) {
  if (!eventName) return;

  try {
    if (typeof window === 'undefined') return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...payload
    });

    if (GTM_DEBUG) {
      console.debug(`[GTM] Event pushed: ${eventName}`, payload);
    }
  } catch (err) {
    if (GTM_DEBUG) {
      console.warn('[GTM] Failed to push event:', eventName, err);
    }
  }
}
